import { render, staticRenderFns } from "./PoFilingLocation.vue?vue&type=template&id=472e526a"
import script from "./PoFilingLocation.vue?vue&type=script&lang=ts"
export * from "./PoFilingLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports